import React from "react";
import { Row, Col } from "reactstrap";
import style from "./Toolbar.module.scss";
import Counter from "./Counter";
import SearchBox from "./SearchBox";

const Toolbar = ({ filteredCount, total, stringFilter, setStringFilter }) => {
  const onSearchChange = (value) => {
    setStringFilter(value);
  };

  return (
    <div className={style.toolbar}>
      <Row>
        <Col md={0} lg={3} xl={2}>
          <Counter filtered={filteredCount} total={total} />
        </Col>
        <Col md={5} xl={6} lg={6}>
          <SearchBox text={stringFilter} changeValue={onSearchChange} />
        </Col>
      </Row>
    </div>
  );
};

export default Toolbar;
